import { motion } from 'framer-motion';
import { useState } from 'react';

const galleryImages = [
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Birthday',
    color: 'from-purple to-pink'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Romantic',
    color: 'from-coral to-pink'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Anniversary',
    color: 'from-coral to-purple'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Just Because',
    color: 'from-pink to-purple'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Birthday',
    color: 'from-purple to-pink'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Romantic',
    color: 'from-coral to-pink'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Anniversary',
    color: 'from-coral to-purple'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Just Because',
    color: 'from-pink to-purple'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Birthday',
    color: 'from-purple to-pink'
  },
  {
    url: 'https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/52245dfb4c8c37645dc59303ffde3857.jpeg',
    category: 'Romantic',
    color: 'from-coral to-pink'
  }
];

export default function Gallery() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-20 bg-cream relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-4 h-4 bg-coral rounded-full"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-pink rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-2 h-2 bg-purple rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-3 h-3 bg-coral rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex justify-between items-start mb-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-coral text-sm font-medium"
          >
            /gallery
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-right"
          >
            <h2 className="font-serif font-black text-4xl md:text-5xl text-charcoal leading-tight">
              Moments We've<br />Brought to Life
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              onHoverStart={() => setHoveredIndex(index)}
              onHoverEnd={() => setHoveredIndex(null)}
              className="relative rounded-2xl overflow-hidden shadow-lg cursor-pointer group"
              style={{ height: index % 3 === 0 ? '400px' : index % 2 === 0 ? '300px' : '350px' }}
            >
              <div className="w-full h-full">
                <img
                  src={image.url}
                  alt={`${image.category} surprise decoration`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className={`absolute inset-0 bg-gradient-to-t ${image.color} opacity-0 group-hover:opacity-90 transition-opacity duration-300 flex items-center justify-center`}>
                <span className="text-white font-semibold text-lg px-6 py-2 bg-white/20 backdrop-blur-sm rounded-full">
                  {image.category}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a href="/gallery" className="text-coral font-medium hover:text-coral/80 transition-colors cursor-pointer whitespace-nowrap">
            View Full Gallery <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
